import axiosInstance from '../../utils/axiosInstance';

// Тягне лише totalCount (pageSize=1). Усі ендпоінти — PaginatedListSearchRequest.
const countOf = async (path: string): Promise<number | null> => {
  try {
    const res = await axiosInstance.post(path, {
      pageIndex: 1,
      pageSize: 1,
      searchString: '',
      orderDirection: '',
    });
    const data = res.data;
    if (typeof data?.totalCount === 'number') return data.totalCount;
    if (Array.isArray(data?.items)) return data.items.length;
    return null;
  } catch {
    return null;
  }
};

export interface ReportStats {
  companies: number | null;
  translators: number | null;
  clients: number | null;
  admins: number | null;
}

export const fetchReportStats = async (): Promise<ReportStats> => {
  const [companies, translators, clients, admins] = await Promise.all([
    countOf('/Admin/GetCompanyList'),
    countOf('/Admin/GetTranslatorsList'),
    countOf('/Admin/GetClientsList'),
    countOf('/Admin/GetAdminList'),
  ]);
  return { companies, translators, clients, admins };
};
